import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import FormAddEditNotificationTemplate from '../../components/notificationTemplates/FormAddEditNotificationTemplate';

import { useCreateNotificationTemplate } from '../../hooks/notificationTemplates/useCreateNotificationTemplate';

const CreateNotificationTemplate = () => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const navigate = useNavigate();

    const { createTemplateAsync, isCreating } = useCreateNotificationTemplate();

    const handleSubmit = async (payload) => {
        try {
            const res = await createTemplateAsync(payload);
            const id = res?.data?.id;
            if (id) {
                navigate(`/settings/notifications/${id}/edit`);
            } else {
                navigate('/settings/notifications');
            }
        } catch {
            // error toast handled by the hook
        }
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <Box sx={{ mb: 2 }}>
                <Typography variant="h5" fontWeight={700}>
                    {isArabic ? 'إضافة قالب إشعار' : 'New notification template'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {isArabic
                        ? 'حدد كود الحدث، القناة، واللغة، ثم اكتب المحتوى. بعد الحفظ ستتمكن من المعاينة والإرسال التجريبي.'
                        : 'Pick the event code, channel, and locale, then write the content. After saving you can preview and test-send.'}
                </Typography>
            </Box>
            <FormAddEditNotificationTemplate
                mode="create"
                onSubmit={handleSubmit}
                isSubmitting={isCreating}
            />
        </WrapperSection>
    );
};

export default CreateNotificationTemplate;
